import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList,{attrs:{"three-line":""}},[_vm._l((_setup.sortedGroups),function(group,groupIndex){return [_c(VSubheader,{key:`subheader-${groupIndex}`},[_vm._v(" "+_vm._s(_vm.t("enum.orderType." + group[0]))+" ")]),_vm._l((group[1]),function(item){return [_c(_setup.OrdersListTile,{key:item.id,attrs:{"order":item,"icon":_vm.icon,"show-from-to-subtitle":""},on:{"click":function($event){return _setup.openOrder(item)}}})]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }